var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-modal',{attrs:{"visible":_vm.videoShow,"footer":null,"title":_vm.videoTitle},on:{"cancel":function($event){return _vm.modalCancel()}}},[_c('div',{staticClass:"video-con",domProps:{"innerHTML":_vm._s(_vm.videoHtml)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }